import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'
import { Layout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'

const { t } = useI18n()

export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    name: 'Root',
    meta: {
      hidden: true
    }
  },
  {
    path: '/redirect',
    component: Layout,
    name: 'Redirect',
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'Redirect',
        component: () => import('@/views/Redirect/Redirect.vue'),
        meta: {}
      }
    ],
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('login.login'),
      noTagsView: true
    }
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFind',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  },
  {
    path: '/403',
    component: () => import('@/views/Error/403.vue'),
    name: 'Forbidden',
    meta: {
      hidden: true,
      title: '403',
      noTagsView: true
    }
  }
]

export const asyncRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/asset',
    component: Layout,
    redirect: '/asset/list',
    name: 'AssetManage',
    meta: {
      title: t('portal.menu.assetManage'),
      icon: 'bx:bxs-component',
      alwaysShow: true
    },
    children: [
      {
        path: 'list',
        component: () => import('@/views/Portal/Assets/index.vue'),
        name: 'AssetList',
        meta: {
          title: t('portal.menu.assetGroup'),
          noCache: true,
          affix: true,
          hideBreadcrumb:false
        },
        children:[
          {
            path: 'detail',
            component: () => import('@/views/Portal/Assets/Detail.vue'),
            name: 'AssetDetail',
            meta: {
              title: t('portal.menu.assetDetail'),
              noCache: true,
              affix: true,
              hideBreadcrumb:true,
              hidden:true,
              activeMenu: '/asset/list',
              activeMenuName:'AssetList'
            }
          }
        ]
      },    
      {
        path: 'property',
        component: () => import('@/views/Portal/Assets/Property.vue'),
        name: 'AssetProperty',
        meta: {
          title: t('portal.menu.assetProperty'),
          noCache: true,
          affix: true,
          hideBreadcrumb:false
        }
      },
      {
        path: 'typeconvert',
        component: () => import('@/views/Portal/Assets/TypeConversion.vue'),
        name: 'TypeConversion',
        meta: {
          title: t('portal.menu.typeConvert'),
          noCache: true,
          affix: true,
          hideBreadcrumb:false
        }
      },
      // {
      //   path: 'tags',
      //   component: () => import('@/views/Portal/Assets/Tags.vue'),
      //   name: 'AssetTags',
      //   meta: {
      //     title: t('portal.menu.assetTag'),
      //     noCache: true,
      //     affix: true,
      //     hideBreadcrumb:false
      //   }
      // },                        
    ]    
  },
  {
    path: '/template',
    component: Layout,
    redirect: '/template/asset',
    name: 'TemplateManage',
    meta: {
      title: t('portal.menu.templateManage'),
      icon: 'bx:bxs-component',
      alwaysShow: true
    },
    children: [
      {
        path: 'asset',
        component: () => import('@/views/Template/AssetTemplate/index.vue'),
        name: 'AssetTemplate',
        meta: {
          title: t('portal.menu.assetTemplate'),
          affix: true,
          hideBreadcrumb: true
        }
      }
    ]
  },
  // {
  //   path: '/alarm',
  //   component: Layout,
  //   redirect: '/alarm/general',
  //   name: 'AlarmSetting',
  //   meta: {
  //     title: t('portal.menu.alarmSetting'),
  //     icon: 'bx:bxs-component',
  //     alwaysShow: true
  //   },
  //   children: [
  //     {
  //       path: 'general',
  //       component: () => import('@/views/Portal/Alarm/index.vue'),
  //       name: 'GeneralAlarmSetting',
  //       meta: {
  //         title: t('portal.menu.GeneralAlarmSetting'),
  //         affix: true,
  //         hideBreadcrumb:false
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/notifysetting',
  //   component: Layout,
  //   redirect: '/notifysetting/messagepush',
  //   name: 'NotifySetting',
  //   meta: {
  //     title: t('portal.menu.notifySetting'),
  //     icon: 'bx:bxs-component',
  //     alwaysShow: true
  //   },
  //   children: [
  //     {
  //       path: 'messagepush',
  //       component: () => import('@/views/NotifySetting/messagepush.vue'),
  //       name: 'Messagepush',
  //       meta: {
  //         title: t('portal.menu.messagepush'),
  //         affix: true,
  //         hideBreadcrumb: true
  //       }
  //     },
  //     {
  //       path: 'apmpush',
  //       component: () => import('@/views/NotifySetting/apmpush.vue'),
  //       name: 'Apmpush',
  //       meta: {
  //         title: t('portal.menu.apmpush'),
  //         affix: true,
  //         hideBreadcrumb: true
  //       }
  //     }
  //   ]
  // },
]

const router = createRouter({
  history: createWebHashHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

export const resetRouter = (): void => {
  const resetWhiteNameList = ['Redirect', 'Login', 'NoFind', 'Root']
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !resetWhiteNameList.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
